var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50112 0.416626C5.18609 0.416626 3.92492 0.93902 2.99505 1.86889C2.06518 2.79876 1.54279 4.05993 1.54279 5.37496V7.87396C1.54289 7.98384 1.51743 8.09224 1.46841 8.19059L0.252204 10.6223C0.192793 10.7411 0.16474 10.8731 0.170709 11.0058C0.176678 11.1385 0.21647 11.2675 0.286307 11.3805C0.356143 11.4934 0.453705 11.5867 0.569726 11.6514C0.685748 11.716 0.816376 11.75 0.949204 11.75H12.053C12.1859 11.75 12.3165 11.716 12.4325 11.6514C12.5485 11.5867 12.6461 11.4934 12.7159 11.3805C12.7858 11.2675 12.8256 11.1385 12.8315 11.0058C12.8375 10.8731 12.8094 10.7411 12.75 10.6223L11.5345 8.19059C11.4853 8.0923 11.4596 7.9839 11.4595 7.87396V5.37496C11.4595 4.05993 10.9371 2.79876 10.0072 1.86889C9.07732 0.93902 7.81615 0.416626 6.50112 0.416626ZM6.50112 13.875C6.06152 13.8751 5.63269 13.7389 5.27368 13.4852C4.91468 13.2315 4.64317 12.8727 4.49654 12.4583H8.5057C8.35907 12.8727 8.08756 13.2315 7.72856 13.4852C7.36956 13.7389 6.94072 13.8751 6.50112 13.875Z",
    fill: "url(#paint0_linear_5196_26637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5196_26637",
    x1: 0.169922,
    y1: 0.416626,
    x2: 13.0911,
    y2: 0.66987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsNotif);
export default __webpack_public_path__ + "static/media/cs-notif.3fe33afd751f015b894f9c110a6e41b9.svg";
export { ForwardRef as ReactComponent };